import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { ValidationResultItem } from '../../typings/common';

import { mobileTrackerDesignerErrors } from './MobileTrackerDesignerErrorHelper/MobileTrackerDesignerErrorHelper';

export const mapMobileTrackingApiErrors = (errors: ValidationResultItem[]): ErrorItem[] => {
    return errors.map(error => {
        return {
            text: mobileTrackerDesignerErrors(error),
            path: error.path
        };
    });
};
